module.exports = __webpack_public_path__ + "a25ce601f28f022b0714ec9ec6becfc6.pdf";